import { useEffect, useState, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  deleteAnswerDataCopy,
  DeleteAttachment,
  fetchAttachmentsForQuestiongid,
  GetAnswerData,
  GetChoicesByQID,
  post_InsertAnswer,
  sendAttachments,
} from "../apis/services/csaApi";
import * as environment from "../apis/env_config/environment";
import en from "../json/en.json";
import ch from "../json/ch.json";

export default function QuestionGroup({
  groupData,
  topic,
  phase,
  activeTab,
  onClose,
  initialOpenEnabler,
  onRadioChange,
}) {
  const lId = localStorage.getItem("languageId") || "1";

  // console.log("groupData in QuestionGroup", groupData);
  const [openSubPanels, setOpenSubPanels] = useState({});
  const [visiblePanels, setVisiblePanels] = useState({});
  const [currentSelections, setCurrentSelections] = useState({});
  const [desiredSelections, setDesiredSelections] = useState({});
  const [remarks, setRemarks] = useState({});
  const [kpiScores, setKpiScores] = useState({});
  const [attachments, setAttachments] = useState({});
  const [uploadingIndex, setUploadingIndex] = useState(null);
  const [optionsMap, setOptionsMap] = useState({});
  const fileInputRefs = useRef([]);
  // const [currentOpenEnabler, setCurrentOpenEnabler] = useState("Human Talent & Organization");

  // Update the initial state to use the prop
  const [currentOpenEnabler, setCurrentOpenEnabler] = useState(
    // initialOpenEnabler || "Human Talent & Organization"
    // initialOpenEnabler || "Standardized Process & Governance"
    initialOpenEnabler || lId === "1"
      ? en.StandardizedProcessnGovernance
      : ch.StandardizedProcessnGovernance
  );
  // console.log("initialOpenEnabler", initialOpenEnabler);

  const toggleSubPanel1 = (enabler, index) => {
    setCurrentOpenEnabler(enabler);
    setOpenSubPanels({
      [`${enabler}-${index}`]: true,
    });
  };

  // Update the useEffect for sub-panels to use the initialOpenEnabler
  useEffect(() => {
    if (initialOpenEnabler) {
      // if(initialOpenEnabler ===
      // label lId === "1" ? en.StandardizedProcessnGovernance : ch.StandardizedProcessnGovernance) {

      const label1 =
        lId === "1"
          ? en.StandardizedProcessnGovernance
          : ch.StandardizedProcessnGovernance;
      const label2 =
        lId === "1" ? en.HumanTalentnOrganization : ch.HumanTalentnOrganization;
      const label3 = lId === "1" ? en.ToolsnTechnology : ch.ToolsnTechnology;
      if (initialOpenEnabler === label1) {
        // alert("0");
        toggleSubPanel1(initialOpenEnabler, 0);
      } else if (initialOpenEnabler === label2) {
        // alert("1");
        toggleSubPanel1(initialOpenEnabler, 1);
      } else if (initialOpenEnabler === label3) {
        // alert("2");
        toggleSubPanel1(initialOpenEnabler, 2);
      }
      // let index = 0;
      // // if (initialOpenEnabler === "Standardized Process & Governance") {
      // // if (initialOpenEnabler === "Human Talent & Organization") {
      // if (initialOpenEnabler === lId === "1" ? en.HumanTalentnOrganization : ch.HumanTalentnOrganization) {
      //   index = 1;
      //   // } else if (initialOpenEnabler === "Tools & Technology") {
      // } else if (initialOpenEnabler === lId === "1" ? en.ToolsnTechnology : ch.ToolsnTechnology) {
      //   index = 2;
      // }
      // setCurrentOpenEnabler(initialOpenEnabler);
      // setOpenSubPanels({ [`${initialOpenEnabler}-${index}`]: true });
    } else {
      // setOpenSubPanels({ "Standardized Process & Governance-0": true });
      const key = `${lId === "1"
        ? en.StandardizedProcessnGovernance
        : ch.StandardizedProcessnGovernance
        }-0`;
      setOpenSubPanels({ [key]: true });
    }
  }, [initialOpenEnabler]);

  const [modalData, setModalData] = useState({
    isOpen: false,
    imageSrc: null,
    title: null,
  });

  const [evidenceModal, setEvidenceModal] = useState({
    isOpen: false,
    title: "",
    content: null, // Can be text or image URL
    contentType: null, // 'text' or 'image'
    qid: null,
  });

  // const [groupedQuestions, setGroupedQuestions] = useState({
  //   "Human Talent & Organization": [],
  //   "Standardized Process & Governance": [],
  //   "Tools & Technology": [],
  // });

  const [groupedQuestions, setGroupedQuestions] = useState(() => {
    const labels = lId === "1" ? en : ch;

    return {
      [labels.StandardizedProcessnGovernance]: [],
      [labels.HumanTalentnOrganization]: [],
      [labels.ToolsnTechnology]: [],
    };
  });

  // Initialize with first sub-panel open
  // useEffect(() => {
  //   setOpenSubPanels({ "Human Talent & Organization-0": true });
  // }, []);

  // Fetch options and initialize questions
  useEffect(() => {
    const fetchOptionsAndInitialize = async () => {
      if (!groupData.allGroupItems) return;

      const newOptionsMap = {};
      // const newGroupedQuestions = {
      //   "Human Talent & Organization": [],
      //   "Standardized Process & Governance": [],
      //   "Tools & Technology": [],
      // };

      const labels = lId === "1" ? en : ch;

      const newGroupedQuestions = {
        [labels.StandardizedProcessnGovernance]: [],
        [labels.HumanTalentnOrganization]: [],
        [labels.ToolsnTechnology]: [],
      };

      for (const item of groupData.allGroupItems) {
        try {
          // Fetch options for each question
          const rawData = await GetChoicesByQID(
            null,
            item.id,
            localStorage.getItem("AssessmentId"),
            localStorage.getItem("userName"),
            localStorage.getItem("languageId")
            // 1
          );

          if (rawData && rawData.length > 0 && rawData[0].length > 0) {
            newOptionsMap[item.id] = rawData[0].map((option) => ({
              text: option.answerText,
              oid: option.oid,
            }));
          } else {
            // Fallback to default options if API returns nothing
            newOptionsMap[item.id] = [
              { text: "Not in Place", oid: 1 },
              { text: "Partially in Place", oid: 2 },
              { text: "Mostly in Place", oid: 3 },
              { text: "Fully in Place", oid: 4 },
            ];
          }

          // Add question to appropriate enabler group
          if (item.enablers && newGroupedQuestions[item.enablers]) {
            newGroupedQuestions[item.enablers].push({
              qid: item.id,
              question: item.questions,
              itemData: item,
              options: newOptionsMap[item.id], // Use the fetched options
            });
          }
        } catch (error) {
          console.error(`Error fetching options for QID ${item.id}:`, error);
          // Fallback to default options on error
          newOptionsMap[item.id] = [
            { text: "Not in Place", oid: 1 },
            { text: "Partially in Place", oid: 2 },
            { text: "Mostly in Place", oid: 3 },
            { text: "Fully in Place", oid: 4 },
          ];
        }
      }

      setOptionsMap(newOptionsMap);
      setGroupedQuestions(newGroupedQuestions);

      // Now fetch attachments and answers
      fetchInitialData(newGroupedQuestions);
    };

    const fetchInitialData = async (groupedQuestions) => {
      try {
        // Fetch attachments
        const attachmentsData = await fetchAttachmentsForQuestiongid(
          localStorage.getItem("uId"),
          localStorage.getItem("AssessmentId"),
          groupData.groupId
        );

        if (attachmentsData?.length > 0) {
          const newAttachments = {};
          attachmentsData.forEach((item) => {
            newAttachments[item.qid] = {
              attachment1: item.attachment1,
              attachment2: item.attachment2,
              attachment3: item.attachment3,
              attachment4: item.attachment4,
              attachment5: item.attachment5,
            };
          });
          setAttachments(newAttachments);
        }

        // Fetch answers
        const answersData = await GetAnswerData(
          localStorage.getItem("uId"),
          localStorage.getItem("AssessmentId"),
          groupData.groupId
        );

        if (answersData?.length > 0) {
          const newCurrentSelections = {};
          const newDesiredSelections = {};
          const newRemarks = {};
          const newKpiScores = {};

          answersData.forEach((item) => {
            const qid = item.qid;
            newRemarks[qid] = item.remark || "";
            newKpiScores[qid] = item.kpiScore || 0;

            // Find the question to get options
            const enabler = Object.keys(groupedQuestions).find((e) =>
              groupedQuestions[e].some((q) => q.qid === qid)
            );
            if (enabler) {
              const question = groupedQuestions[enabler].find(
                (q) => q.qid === qid
              );
              if (question) {
                // Find current selection index
                const currentIndex = question.options.findIndex(
                  (opt) => opt.oid === item.currentID
                );
                if (currentIndex !== -1) {
                  newCurrentSelections[qid] = currentIndex;
                }

                // Find desired selection index
                const desiredIndex = question.options.findIndex(
                  (opt) => opt.oid === item.destinationID
                );
                if (desiredIndex !== -1) {
                  newDesiredSelections[qid] = desiredIndex;
                }
              }
            }
          });

          setCurrentSelections(newCurrentSelections);
          setDesiredSelections(newDesiredSelections);
          setRemarks(newRemarks);
          setKpiScores(newKpiScores);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchOptionsAndInitialize();
  }, [groupData.groupId, groupData.allGroupItems]);

  const toggleSubPanel = (enabler, index) => {
    // setCurrentOpenEnabler(enabler,index);
    toggleSubPanel1(enabler, index);
    setOpenSubPanels({
      [`${enabler}-${index}`]: true,
    });
  };

  const toggleQuestionPanel = (qid, groupName, evidence) => {
    setVisiblePanels((prev) => ({
      ...prev,
      [qid]: !prev[qid],
    }));
    openEvidenceModal(
      groupName,
      evidence, // This should be either text or image path
      qid
    );
  };

  const handleCurrentChange = async (qid, index) => {
    const enabler = Object.keys(groupedQuestions).find((e) =>
      groupedQuestions[e].some((q) => q.qid === qid)
    );
    const question = groupedQuestions[enabler]?.find((q) => q.qid === qid);

    if (!question) return;

    const newCurrentSelections = {
      ...currentSelections,
      [qid]: index,
    };
    setCurrentSelections(newCurrentSelections);

    // If desired selection is now invalid, clear it
    if (
      desiredSelections[qid] !== undefined &&
      desiredSelections[qid] < index
    ) {
      const newDesiredSelections = { ...desiredSelections };
      delete newDesiredSelections[qid];
      setDesiredSelections(newDesiredSelections);
    }

    await saveAnswer(qid, {
      currentIndex: index,
      desiredIndex: desiredSelections[qid],
      remark: remarks[qid],
      kpiScore: kpiScores[qid],
    });
    if (onRadioChange) {
      onRadioChange(activeTab);
    }
  };

  const handleDesiredChange = async (qid, index) => {
    // Validate desired can't be less than current
    if (
      currentSelections[qid] !== undefined &&
      index < currentSelections[qid]
    ) {
      return;
    }

    const newDesiredSelections = {
      ...desiredSelections,
      [qid]: index,
    };
    setDesiredSelections(newDesiredSelections);

    await saveAnswer(qid, {
      currentIndex: currentSelections[qid],
      desiredIndex: index,
      remark: remarks[qid],
      kpiScore: kpiScores[qid],
    });
    if (onRadioChange) {
      onRadioChange(activeTab);
    }
  };

  const handleRemarksChange = async (qid, value) => {
    const newRemarks = {
      ...remarks,
      [qid]: value,
    };
    setRemarks(newRemarks);

    await saveAnswer(qid, {
      currentIndex: currentSelections[qid],
      desiredIndex: desiredSelections[qid],
      remark: value,
      kpiScore: kpiScores[qid],
    });
  };

  const handleKpiScoreChange = async (qid, value) => {
    const score = parseInt(value) || 0;
    const newKpiScores = {
      ...kpiScores,
      [qid]: score,
    };
    setKpiScores(newKpiScores);

    await saveAnswer(qid, {
      currentIndex: currentSelections[qid],
      desiredIndex: desiredSelections[qid],
      remark: remarks[qid],
      kpiScore: score,
    });
  };

  const saveAnswer = async (
    qid,
    { currentIndex, desiredIndex, remark, kpiScore }
  ) => {
    const enabler = Object.keys(groupedQuestions).find((e) =>
      groupedQuestions[e].some((q) => q.qid === qid)
    );
    const question = groupedQuestions[enabler]?.find((q) => q.qid === qid);

    if (!question) return;

    try {
      const response = await post_InsertAnswer({
        qid: qid,
        Cid:
          currentIndex !== undefined ? question.options[currentIndex].oid : 0,
        DId:
          desiredIndex !== undefined ? question.options[desiredIndex].oid : 0,
        UId: localStorage.getItem("uId"),
        AID: localStorage.getItem("AssessmentId"),
        Remarks: remark || "",
        Eid: question.itemData.enablerId || 0,
        GID: groupData.groupId || 0,
        Fid: 0,
        GroupName: groupData.groupname || "",
        UserName: localStorage.getItem("userName"),
        Ip: "",
        kpiScore: kpiScore || 0,
      });

      // console.log("Answer saved:", response);
    } catch (error) {
      console.error("Error saving answer:", error);
    }
  };

  const handleFileUpload = async (qid, index, e) => {
    // console.log("File upload triggered for QID:", qid, "Index:", index);

    const file = e.target.files[0];
    if (!file) return;

    setUploadingIndex(index);
    const attachmentKey = `attachment${index + 1}`;

    try {
      const currentEnablerQuestions =
        groupedQuestions[currentOpenEnabler] || [];
      // console.log("Current enabler questions:", currentEnablerQuestions);
      // const isValidQid = currentEnablerQuestions.some(q => q.qid === qid);
      // console.log("Is valid QID for current enabler:", isValidQid);
      // console.log("currentEnablerQuestions[0].qid:", currentEnablerQuestions[0]?.qid);

      // if (currentEnablerQuestions) {
      //   alert(
      //     "currentEnablerQuestions[0]?.qid:",
      //     currentEnablerQuestions[0]?.qid
      //   );
      // }

      const uploadResponse = await sendAttachments({
        file,
        qid: currentEnablerQuestions[0]?.qid,
        index: index + 1,
        assessmentId: localStorage.getItem("AssessmentId"),
        userName: localStorage.getItem("userName"),
        uid: localStorage.getItem("uId"),
        gid: groupData.groupId,
      });

      const filePath = uploadResponse.filePath;

      setAttachments((prev) => ({
        ...prev,
        [currentEnablerQuestions[0]?.qid]: {
          ...prev[currentEnablerQuestions[0]?.qid],
          [attachmentKey]: filePath,
        },
      }));

      // Save answer to update attachment references
      await saveAnswer(currentEnablerQuestions[0]?.qid, {
        currentIndex: currentSelections[currentEnablerQuestions[0]?.qid],
        desiredIndex: desiredSelections[currentEnablerQuestions[0]?.qid],
        remark: remarks[currentEnablerQuestions[0]?.qid],
        kpiScore: kpiScores[currentEnablerQuestions[0]?.qid],
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setUploadingIndex(null);
      e.target.value = "";
    }
  };

  // const handleDeleteAttachment = async (qid, index) => {
  //   const attachmentKey = `attachment${index + 1}`;

  //   setAttachments((prev) => {
  //     const newAttachments = { ...prev };
  //     if (newAttachments[qid]) {
  //       newAttachments[qid] = { ...newAttachments[qid] };
  //       delete newAttachments[qid][attachmentKey];
  //     }
  //     return newAttachments;
  //   });

  //   // Save answer to update attachment references
  //   await saveAnswer(qid, {
  //     currentIndex: currentSelections[qid],
  //     desiredIndex: desiredSelections[qid],
  //     remark: remarks[qid],
  //     kpiScore: kpiScores[qid],
  //   });
  // };

  const handleDeleteAttachment = async (qid, index) => {
    try {
      const currentEnablerQuestions =
        groupedQuestions[currentOpenEnabler] || [];
      // Prepare the data for deletion
      const deleteData = {
        UID: parseInt(localStorage.getItem("uId")),
        // QID: currentEnablerQuestions[0]?.qid,
        QID: qid,
        AID: parseInt(localStorage.getItem("AssessmentId")),
        AttachmentNumber: index + 1, // Convert 0-based index to 1-based
      };

      // Call the delete API
      const response = await DeleteAttachment(deleteData);

      if (response) {
        // Update local state to remove the attachment
        setAttachments((prev) => {
          const newAttachments = { ...prev };
          if (newAttachments[qid]) {
            newAttachments[qid] = { ...newAttachments[qid] };
            delete newAttachments[qid][`attachment${index + 1}`];
          }
          return newAttachments;
        });

        // Save answer to update attachment references
        await saveAnswer(qid, {
          currentIndex: currentSelections[qid],
          desiredIndex: desiredSelections[qid],
          remark: remarks[qid],
          kpiScore: kpiScores[qid],
        });

        // Optional: Show success message
        // alert("Attachment deleted successfully");
      }
      // else {
      //   alert("Failed to delete attachment: " + response);
      // }
    } catch (error) {
      console.error("Error deleting attachment:", error);
      alert("Error deleting attachment: " + error.message);
    }
  };

  const openImageModal = (src, title = null) => {
    setModalData({ isOpen: true, imageSrc: src, title });
  };

  const closeModal = () => {
    setModalData({ isOpen: false, imageSrc: null, title: null });
  };

  const openEvidenceModal = (groupName, evidenceData, qid) => {
    // Determine content type
    let contentType = null;
    let content = evidenceData;

    // if (typeof evidenceData === "string" && evidenceData.trim() !== "") {
    //   if (/\.(jpg|jpeg|png|gif|webp)$/i.test(evidenceData)) {
    //     contentType = "image";
    //     content = environment.imageUrl + evidenceData;
    //   } else {
    //     contentType = "text";
    //     content = evidenceData;
    //   }
    // }

    setEvidenceModal({
      isOpen: true,
      groupName,
      content,
      contentType,
      qid,
    });
  };

  useEffect(() => {
    if (modalData.isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [modalData.isOpen]);

  // const categories = [
  //   "Standardized Process & Governance",
  //   "Human Talent & Organization",
  //   "Tools & Technology",
  // ];

  const labels = lId === "1" ? en : ch;

  const categories = [
    labels.StandardizedProcessnGovernance,
    labels.HumanTalentnOrganization,
    labels.ToolsnTechnology,
  ];


  // Add this function to handle clearing the answer
  const handleClearAnswer = async (qid) => {
    try {
      const payload = {
        UserID: parseInt(localStorage.getItem("uId")),
        Qid: qid,
        AssesmentID: parseInt(localStorage.getItem("AssessmentId"))
      };

      const response = await deleteAnswerDataCopy(payload);

      // Update local state to clear the answer
      setCurrentSelections(prev => {
        const newState = { ...prev };
        delete newState[qid];
        return newState;
      });

      setDesiredSelections(prev => {
        const newState = { ...prev };
        delete newState[qid];
        return newState;
      });

      setRemarks(prev => ({
        ...prev,
        [qid]: ""
      }));

      setKpiScores(prev => ({
        ...prev,
        [qid]: 0
      }));

      // Show success message
      alert(lId === "1" ? "Answer cleared successfully" : "答案清除成功");
    } catch (error) {
      console.error("Error clearing answer:", error);
      alert(lId === "1" ? "Error clearing answer" : "清除答案时出错");
    }
  };

  return (
    <div className="question-group-container active">
      {/* <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold">
          {groupData.groupname} Questions
        </h2>
        <button
          onClick={onClose}
          className="bg-[#f40009] text-white px-4 py-2 rounded-md"
        >
          Close
        </button>
      </div> */}

      <div className="sub-panel-container">
        <div className="horizontal-panels">
          {categories.map((category, panelIdx) => {
            const questions = groupedQuestions[category] || [];

            return (
              <div
                key={panelIdx}
                className={`panel flex ${openSubPanels[`${category}-${panelIdx}`] ? "w-full" : "w-auto"
                  }`}
              >
                {/* Vertical Toggle Button */}
                <button
                  className={`panel-button ${openSubPanels[`${category}-${panelIdx}`]
                    ? "bg-[#3a3a3a]"
                    : "bg-[#7f7f7f]"
                    }`}
                  onClick={() => toggleSubPanel(category, panelIdx)}
                >
                  <span
                    style={{
                      transform: `rotate(${lId === "1" ? "180deg" : "0deg"})`,
                    }}
                    className="vertical-text"
                  >
                    {category === "Standardized Process & Governance" && (
                      <img src="/assets/main/process.svg" alt="" />
                    )}
                    {category === "Human Talent & Organization" && (
                      <img src="/assets/main/hr.svg" alt="" />
                    )}
                    {category === "Tools & Technology" && (
                      <img src="/assets/main/it.svg" alt="" />
                    )}
                    {category}
                  </span>
                </button>

                {/* Scrollable Content */}
                <div
                  className={`question-content-container ${openSubPanels[`${category}-${panelIdx}`]
                    ? "opacity-100 block"
                    : "opacity-0 hidden"
                    }`}
                >
                  {questions.length > 0 ? (
                    // groupedQuestions[currentOpenEnabler]?.map((questionData, qIndex) => {
                    questions.map((questionData, qIndex) => {
                      const item = questionData.itemData;
                      return (
                        <div key={qIndex} className="question-container">
                          {/* Question Header */}
                          <div className="question">
                            <p>
                              {/* {qIndex + 1}.  */}
                              {/* {item.question_Seq}. {questionData.question} */}
                              {item.id}. {questionData.question}
                            </p>
                            
                            {phase.toUpperCase() !== "INITIATIVES" &&
                              phase.toUpperCase() !== "KPI" && (
                                <span
                                  onClick={() =>
                                    toggleQuestionPanel(
                                      questionData.qid,
                                      item.groupName,
                                      item.evidence
                                    )
                                  }
                                  className="e-outer-span"
                                >
                                  <span className="e-inner-span">e</span>
                                </span>
                              )}
                            {item?.hqLink && (
                              <span
                                onClick={() =>
                                  openImageModal(
                                    environment.imageUrl + item.hqLink,
                                    item.groupName
                                  )
                                }
                                className="i-outer-span"
                              >
                                <span className="i-inner-span">i</span>
                              </span>
                            )}
                            {/* <button
                              onClick={() => handleClearAnswer(questionData.qid)}
                              className="clear-button"
                              title={lId === "1" ? "Clear answer" : "清除答案"}
                            >
                              ×
                            </button> */}
                          </div>

                          {/* Evidence Panel */}
                          {/* <div
                            className={`overflow-hidden transition-all duration-200 linear ${visiblePanels[questionData.qid]
                              ? "opacity-100 py-4"
                              : "opacity-0 py-0"
                              } my-4 px-6 bg-gray-100 border rounded-md text-[2.1rem]`}
                            style={{
                              maxHeight: visiblePanels[questionData.qid]
                                ? "1000px"
                                : "0",
                            }}
                          >
                            <p>
                              <strong>{item.evidence}</strong>
                            </p>
                          </div> */}

                          {/* Options Table */}
                          <div className="list-banner">
                            <p>{lId === "1" ? en.OPTIONS : ch.OPTIONS}</p>
                            <p>{lId === "1" ? en.CURRENT : ch.CURRENT}</p>
                            <p>{lId === "1" ? en.DESIRED : ch.DESIRED}</p>
                          </div>

                          {/* Options List */}
                          <div className="option-rows">
                            {questionData.options.map((option, index) => (
                              <div key={index} className={`option`}>
                                <div className="sequence">
                                  <p>
                                    {index + 1 === 1
                                      ? "A"
                                      : index + 1 === 2
                                        ? "B"
                                        : index + 1 === 3
                                          ? "C"
                                          : "D"}
                                  </p>
                                </div>
                                <p className="option-text">{option.text}</p>
                                <div
                                  className="option-container current-option-container"
                                  onClick={() =>
                                    handleCurrentChange(questionData.qid, index)
                                  }
                                >
                                  <input
                                    type="radio"
                                    name={`current-${questionData.qid}`}
                                    value={index}
                                    checked={
                                      currentSelections[questionData.qid] ===
                                      index
                                    }
                                    onChange={() =>
                                      handleCurrentChange(
                                        questionData.qid,
                                        index
                                      )
                                    }
                                  />
                                </div>
                                <div
                                  className="option-container"
                                  onClick={() =>
                                    handleDesiredChange(questionData.qid, index)
                                  }
                                >
                                  <input
                                    type="radio"
                                    name={`desired-${questionData.qid}`}
                                    value={index}
                                    checked={
                                      desiredSelections[questionData.qid] ===
                                      index
                                    }
                                    onChange={() =>
                                      handleDesiredChange(
                                        questionData.qid,
                                        index
                                      )
                                    }
                                    disabled={
                                      currentSelections[questionData.qid] !==
                                      undefined &&
                                      index <
                                      currentSelections[questionData.qid]
                                    }
                                    className={`${currentSelections[questionData.qid] !==
                                      undefined &&
                                      index <
                                      currentSelections[questionData.qid]
                                      ? "opacity-50 cursor-not-allowed"
                                      : ""
                                      }`}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Remarks and KPI Score */}
                          <div className="support-container">
                            <div className="remark-kpi-container">
                              {/* Remarks */}
                              <div className="remark-section">
                                <label>
                                  {lId === "1" ? en.remarks : ch.remarks}
                                </label>
                                <textarea
                                  rows={1}
                                  placeholder={
                                    lId === "1"
                                      ? en.writeRemark
                                      : ch.writeRemark
                                  }
                                  value={remarks[questionData.qid] || ""}
                                  onChange={(e) =>
                                    handleRemarksChange(
                                      questionData.qid,
                                      e.target.value
                                    )
                                  }
                                  className="textarea"
                                  onInput={(e) => {
                                    e.target.style.height = "auto";
                                    e.target.style.height =
                                      e.target.scrollHeight + "px";
                                  }}
                                />
                              </div>

                              {/* KPI Score */}
                              <div className="kpi-section">
                                <label>
                                  KPI {lId === "1" ? en.score : ch.score}
                                </label>
                                <input
                                  type="number"
                                  value={kpiScores[questionData.qid] || ""}
                                  onChange={(e) =>
                                    handleKpiScoreChange(
                                      questionData.qid,
                                      e.target.value
                                    )
                                  }
                                  // placeholder="Enter score"
                                  className="input"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>

                            {/* Attachments */}
                            <div className="attachment-container">
                              <div className="upload-section">
                                <label>
                                  {lId === "1"
                                    ? en.attachments
                                    : ch.attachments}
                                </label>

                                {/* Conditional rendering based on attachment count */}
                                {[0, 1, 2, 3, 4].every((index) => {
                                  const attachmentKey = `attachment${index + 1
                                    }`;
                                  return attachments[questionData.qid]?.[
                                    attachmentKey
                                  ];
                                }) ? (
                                  // Display when all slots are full
                                  <div className="upload-full-message">
                                    <div className="message-section">
                                      <svg
                                        className="text-green-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        ></path>
                                      </svg>
                                      {/* <p className="text-top text-3xl font-medium text-gray-700">
                                        Maximum attachments reached
                                      </p>
                                      <p className="text-bottom text-2xl text-gray-500">
                                        Please delete files to add new ones
                                      </p> */}
                                      <p className="text-top text-3xl font-medium text-gray-700">
                                        {lId === "1"
                                          ? en.maximumattachmentsreached
                                          : ch.maximumattachmentsreached}
                                      </p>
                                      <p className="text-bottom text-2xl text-gray-500">
                                        {lId === "1"
                                          ? en.pleasedeletefilestoaddnewones
                                          : ch.pleasedeletefilestoaddnewones}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  // Display when slots are available
                                  <div
                                    className="upload transition-colors"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      //   {
                                      //   fileInputRefs.current[0]?.click();
                                      // }

                                      // Find first available slot
                                      const currentAttachments =
                                        attachments[questionData.qid] || {};
                                      // console.log("currentAttachments", currentAttachments);
                                      let availableIndex = 0;
                                      while (
                                        availableIndex < 5 &&
                                        currentAttachments[
                                        `attachment${availableIndex + 1}`
                                        ]
                                      ) {
                                        availableIndex++;
                                        // console.log("availableIndex", availableIndex);
                                      }

                                      if (
                                        availableIndex < 5 &&
                                        fileInputRefs.current[availableIndex]
                                      ) {
                                        fileInputRefs.current[
                                          availableIndex
                                        ].click();
                                        // console.log("File input clicked for index:", availableIndex);
                                      }
                                    }}
                                    onDragOver={(e) => {
                                      e.preventDefault();
                                    }}
                                    onDragLeave={(e) => {
                                      e.preventDefault();
                                    }}
                                    onDrop={(e) => {
                                      e.preventDefault();
                                      if (e.dataTransfer.files.length > 0) {
                                        const currentAttachments =
                                          attachments[questionData.qid] || {};
                                        let availableIndex = 0;
                                        while (
                                          availableIndex < 5 &&
                                          currentAttachments[
                                          `attachment${availableIndex + 1}`
                                          ]
                                        ) {
                                          availableIndex++;
                                        }

                                        if (
                                          availableIndex < 5 &&
                                          fileInputRefs.current[availableIndex]
                                        ) {
                                          const dataTransfer =
                                            new DataTransfer();
                                          Array.from(
                                            e.dataTransfer.files
                                          ).forEach((file) => {
                                            dataTransfer.items.add(file);
                                          });
                                          fileInputRefs.current[
                                            availableIndex
                                          ].files = dataTransfer.files;
                                          const event = new Event("change", {
                                            bubbles: true,
                                          });
                                          fileInputRefs.current[
                                            availableIndex
                                          ].dispatchEvent(event);
                                        }
                                      }
                                    }}
                                  >
                                    {/* <input
                                      type="file"
                                      ref={(el) => {
                                        if (el && !fileInputRefs.current[0]) {
                                          fileInputRefs.current[0] = el;
                                        }
                                      }}
                                      onChange={(e) => {
                                        if (
                                          e.target.files &&
                                          e.target.files.length > 0
                                        ) {
                                          for (let i = 0; i < 5; i++) {
                                            const attachmentKey = `attachment${i + 1
                                              }`;
                                            if (
                                              !attachments[questionData.qid]?.[
                                              attachmentKey
                                              ]
                                            ) {
                                              handleFileUpload(
                                                questionData.qid,
                                                i,
                                                e
                                              );
                                              break;
                                            }
                                          }
                                        }
                                      }}
                                      className="hidden"
                                      accept="image/*,.pdf,.doc,.docx,.xlsx"
                                      multiple
                                    /> */}
                                    {[0, 1, 2, 3, 4].map((index) => (
                                      <input
                                        key={index}
                                        type="file"
                                        ref={(el) =>
                                          (fileInputRefs.current[index] = el)
                                        }
                                        onChange={(e) => {
                                          if (
                                            e.target.files &&
                                            e.target.files.length > 0
                                          ) {
                                            handleFileUpload(
                                              questionData.qid,
                                              index,
                                              e
                                            );
                                          }
                                        }}
                                        className="hidden"
                                        accept="image/*,.pdf,.doc,.docx,.xlsx"
                                        onClick={(e) => e.stopPropagation()}
                                      />
                                    ))}
                                    <div className="upload-message">
                                      <svg
                                        className="text-gray-300"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                        ></path>
                                      </svg>
                                      <p className="text-top">
                                        {lId === "1"
                                          ? en.uploadaFile
                                          : ch.uploadaFile}
                                      </p>
                                      <p className="text-bottom">
                                        {lId === "1"
                                          ? en.draganddropfileshere
                                          : ch.draganddropfileshere}
                                      </p>
                                      {/* <p className="text-top">Upload a File</p>
                                      <p className="text-bottom">
                                        Drag and drop files here
                                      </p> */}
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Attachments list remains the same */}
                              <div className="attachment-section">
                                {[0, 1, 2, 3, 4].map((index) => {
                                  const attachmentKey = `attachment${index + 1
                                    }`;
                                  const attachmentUrl =
                                    attachments[questionData.qid]?.[
                                    attachmentKey
                                    ];

                                  if (!attachmentUrl) return null;

                                  const fileName = attachmentUrl
                                    .split("/")
                                    .pop();
                                  const displayName =
                                    fileName.length > 22
                                      ? `${fileName.substring(
                                        0,
                                        19
                                      )}...${fileName.split(".").pop()}`
                                      : fileName;
                                  const isImage =
                                    /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(
                                      attachmentUrl
                                    );

                                  return (
                                    <div key={index} className="attachment-row">
                                      <div className="attachment-row-inner">
                                        {isImage ? (
                                          <div className="img-container">
                                            <img
                                              src={
                                                environment.imageUrl +
                                                attachmentUrl
                                              }
                                              alt={fileName}
                                            />
                                          </div>
                                        ) : (
                                          <div className="flie-icon-container">
                                            {(() => {
                                              const extension = fileName
                                                .split(".")
                                                .pop()
                                                .toLowerCase();

                                              switch (extension) {
                                                case "pdf":
                                                  return (
                                                    <img
                                                      className="file-icon"
                                                      src="/assets/main/pdf.png"
                                                      alt=""
                                                    />
                                                  );
                                                case "doc":
                                                case "docx":
                                                  return (
                                                    <img
                                                      className="file-icon"
                                                      src="/assets/main/doc.png"
                                                      alt=""
                                                    />
                                                  );
                                                case "xls":
                                                case "xlsx":
                                                  return (
                                                    <img
                                                      className="file-icon"
                                                      src="/assets/main/xls.png"
                                                      alt=""
                                                    />
                                                  );
                                                case "ppt":
                                                case "pptx":
                                                  return (
                                                    <img
                                                      className="file-icon"
                                                      src="/assets/main/ppt.png"
                                                      alt=""
                                                    />
                                                  );
                                                default:
                                                  return (
                                                    <span className="file-icon-default text-gray-600">
                                                      📄
                                                    </span>
                                                  );
                                              }
                                            })()}
                                          </div>
                                        )}
                                        <p
                                          className="file-name"
                                          title={fileName}
                                        >
                                          {displayName}
                                        </p>
                                      </div>

                                      <div className="attachment-button">
                                        <a
                                          href={
                                            environment.imageUrl + attachmentUrl
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="view-button"
                                        >
                                          {lId === "1" ? en.view : ch.view}
                                        </a>
                                        <button
                                          onClick={() => {
                                            const input =
                                              document.createElement("input");
                                            input.type = "file";
                                            input.accept =
                                              "image/*,.pdf,.doc,.docx";
                                            input.onchange = (e) => {
                                              if (
                                                e.target.files &&
                                                e.target.files.length > 0
                                              ) {
                                                handleFileUpload(
                                                  questionData.qid,
                                                  index,
                                                  e
                                                );
                                              }
                                            };
                                            input.click();
                                          }}
                                          className="replace-button"
                                        >
                                          {lId === "1"
                                            ? en.replace
                                            : ch.replace}
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDeleteAttachment(
                                              questionData.qid,
                                              index
                                            )
                                          }
                                          className="delete-button"
                                        >
                                          {lId === "1" ? en.delete : ch.delete}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-gray-500 text-center py-8">
                      {lId === "1"
                        ? en.noquestionsavailablefor
                        : ch.noquestionsavailablefor}{" "}
                      {category}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {modalData.isOpen && (
        <div className="modal-container">
          <div className="modal">
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            {modalData.title && (
              <h2 className="text-3xl font-bold mb-4">{modalData.title}</h2>
            )}
            <img
              src={modalData.imageSrc}
              alt="Modal content"
              className="modal-img"
            />
          </div>
        </div>
      )}
      {evidenceModal.isOpen && (
        <div className="modal-container">
          <div className="modal">
            {/* Close Button */}
            <button
              onClick={() =>
                setEvidenceModal({ ...evidenceModal, isOpen: false })
              }
              className="modal-close"
            >
              ×
            </button>

            {/* Modal Header */}
            {/* <div className="border-b p-6">
              <h2 className="text-4xl font-bold">
                {evidenceModal.title}
              </h2>
            </div> */}

            {/* <div className="flex-1 overflow-auto p-6">
              {evidenceModal.contentType === 'text' && (
                <div className="text-3xl leading-relaxed whitespace-pre-wrap">
                  {evidenceModal.content}
                </div>
              )}

              {evidenceModal.contentType === 'image' && (
                <div className="h-full flex items-center justify-center p-4">
                  <img
                    src={evidenceModal.content}
                    alt="Evidence"
                    className="max-h-full max-w-full object-contain"
                    style={{
                      maxHeight: 'calc(90vh - 200px)',
                      maxWidth: '100%',
                      width: '100%',
                    }}
                  />
                </div>
              )}

              {!evidenceModal.contentType && (
                <div className="h-full flex items-center justify-center text-3xl text-gray-500">
                  No evidence content available
                </div>
              )}
            </div> */}

            <h2>{evidenceModal.content}</h2>
            <img
              src={`/assets/questionEvidance/question${lId === "1" ? "en" : "en"
                }-${evidenceModal?.qid}.png`}
              alt="Modal content"
              className="modal-img"
            />

            {/* Footer (only for images) */}
            <div className="footer-link">
              <a
                href={`/assets/questionEvidance/question${lId === "1" ? "en" : "en"
                  }-${evidenceModal?.qid}.png`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open image in new tab
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
